export default __webpack_public_path__ + "static/media/Johannes_glad.08829647.jpg";